import { gql, TypedDocumentNode } from '@common/hooks';
import { EXTENSION_OFFER_FRAGMENT } from '@working-experience/graphql/fragments';
import {
  ExtensionOfferQueryQueryCgResponse,
  ExtensionOfferQueryQueryVariables,
} from '@common/graphql';

export type ExtensionOfferType =
  ExtensionOfferQueryQueryCgResponse['extensionOffer'];

export type ExtensionOfferAssignmentType =
  ExtensionOfferType['staffingRequestAssignment'];

export type ExtensionOfferApplicationType =
  ExtensionOfferAssignmentType['staffingRequestApplication'];

export type ExtensionOfferStaffingRequestType =
  ExtensionOfferApplicationType['staffingRequest'];

export type ExtensionOfferOrganizationUnitType =
  ExtensionOfferStaffingRequestType['organizationUnit'];

export const EXTENSION_OFFER_QUERY: TypedDocumentNode<
  ExtensionOfferQueryQueryCgResponse,
  ExtensionOfferQueryQueryVariables
> = gql`
  query ExtensionOfferQuery($id: ID!) {
    extensionOffer(id: $id) {
      id
      ...ExtensionOfferFragment
      staffingRequestAssignment {
        id
        startDate
        finalEndDate
        billingRegularRate
        shiftsPerWeek
        hoursPerShift
        employmentType
        organization {
          id
          name
        }
        lastAssignmentTerm {
          id
          overtimeThreshold
          organizationUnit {
            id
          }
        }
        worksProfile {
          id
          fullName
        }
        supplier {
          id
          name
        }
        staffingRequestApplication {
          id
          worksProfile {
            id
            fullName
          }
          organization {
            id
            name
            organizationSetting {
              id
              timekeepingEnabled
            }
          }
          staffingRequest {
            id
            code
            externalId
            startDate
            endDate
            shiftType
            shiftsPerWeek
            hoursPerShift
            billingRegularRate
            staffingRequestType
            roleLevel
            role {
              id
              abbreviation
            }
            organizationUnit {
              id
              department {
                id
                name
                organizationBusiness {
                  id
                  name
                  city
                  stateCode
                }
              }
            }
          }
        }
      }
    }
  }
  ${EXTENSION_OFFER_FRAGMENT}
`;
